import { useState } from 'react';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { View } from 'foundations-components/transitional/components/View';
import { LowLevelAuthFlowView } from '../shared/components/LowLevelAuthFlowView';
import { useAuthConfigFetch } from '../shared/hooks/useAuthConfigFetch';
import { AuthConfigLoadingState, AuthConfigFetchFailureState } from '../shared/components/AuthConfigStates';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
// Re-export for consumers that imported from here (backward compat)
export { AuthConfigLoadingState, AuthConfigFetchFailureState };
export function UnifiedAuthView({
  isModal,
  isReauth = false,
  portalId,
  accountId,
  appName,
  modalSettings,
  onComplete,
  onCancel = () => {},
  fetchAuthConfig,
  useIntroScreen,
  useSuccessScreen,
  onAuthError,
  debug = false
}) {
  var _modalSettings$width, _modalSettings$use;
  const configFetchState = useAuthConfigFetch(fetchAuthConfig);
  const [isAuthInProgress, setIsAuthInProgress] = useState(false);
  const children = /*#__PURE__*/_jsx(_Fragment, {
    children: configFetchState.status === 'pending' ? /*#__PURE__*/_jsx(AuthConfigLoadingState, {
      isModal: isModal,
      onCancel: onCancel
    }) : configFetchState.status === 'succeeded' ? /*#__PURE__*/_jsx(LowLevelAuthFlowView, {
      isModal: isModal,
      isReauth: isReauth,
      portalId: portalId,
      authConfig: configFetchState.config,
      onComplete: payload => {
        if (onComplete) onComplete(payload);
      },
      onCancel: onCancel,
      accountId: accountId,
      useIntroScreen: useIntroScreen,
      useSuccessScreen: useSuccessScreen,
      onError: onAuthError,
      onAuthInProgressChange: setIsAuthInProgress,
      debug: debug
    }) : /*#__PURE__*/_jsx(AuthConfigFetchFailureState, {
      isModal: isModal,
      onClose: onCancel,
      appName: appName,
      isReauth: isReauth,
      error: configFetchState.err
    })
  });
  return isModal ? /*#__PURE__*/_jsx(Modal, {
    "data-test-id": "unified-auth-modal",
    width: (_modalSettings$width = modalSettings === null || modalSettings === void 0 ? void 0 : modalSettings.width) !== null && _modalSettings$width !== void 0 ? _modalSettings$width : 550,
    size: modalSettings === null || modalSettings === void 0 ? void 0 : modalSettings.size,
    use: (_modalSettings$use = modalSettings === null || modalSettings === void 0 ? void 0 : modalSettings.use) !== null && _modalSettings$use !== void 0 ? _modalSettings$use : 'default',
    onEsc: isAuthInProgress ? () => {} : undefined,
    children: children
  }) : /*#__PURE__*/_jsx(View, {
    "data-test-id": "unified-auth-form",
    children: children
  });
}